export default __webpack_public_path__ + "static/media/logo.fc3e6875.svg";